<!-- 由 suu 创建于 2022-01-07 星期五 -->
<template>
  <div class="ItemMealCard">
    <div class="c-item" v-for="(item, index) in cardArr" :key="index">
      <!-- 标题 -->
      <div class="i-title">{{ item.title }}</div>
      <div class="i-cent">
        <!-- 加餐 -->
        <div class="c-num" v-if="!item.sub">
          {{ info[type][item.key].clock }}
        </div>
        <!-- 其他 -->
        <template v-else>
          <!-- 打卡数/点评数  -->
          <div
            class="c-nums"
            :class="{ 'c-nums-risk': info[type][item.key].risk }"
          >
            {{ info[type][item.key].clock }}/<span>{{
              info[type][item.key].all
            }}</span>
          </div>
          <!-- 标签 -->
          <div
            class="c-tag"
            :style="{ backgroundColor: cTagColor(t.type) }"
            v-for="(t, ti) in info[type][item.key].tags"
            :key="ti"
          >
            {{ t.text }}
          </div>
          <div class="i-bot">
            <div class="c-sub">
              <div>{{ item.sub }}</div>
              <div
                class="sub-num"
                :class="{
                  'sub-num-risk':
                    info[type][item.key].risk ||
                    commentRisk(info[type][item.key].tags)
                }"
              >
                {{ info[type][item.key].subValue }}
              </div>
            </div>
            <div class="c-sub" :class="{ 'c-sub-gray': type == 'clock' }">
              <div>{{ item.sub2 }}</div>
              <div
                class="sub-num"
                :class="{
                  'sub-num-risk': timeRisk(info[type][item.key].tags)
                }"
              >
                {{ info[type][item.key].subValue2 }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemMealCard',

  components: {},

  props: {
    cardArr: {},
    info: {},
    type: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 获取打卡标签颜色
     */
    cTagColor(type) {
      switch (type) {
        case 1:
          return '#F04646'
        case 3:
          return '#35C763'
        default:
          return '#2882E9'
      }
    },
    /**
     * 超时点评是否警告
     */
    commentRisk(tags) {
      return tags.find((v) => v.text == '超时点评')
    },
    /**
     * 平均用时是否警告
     */
    timeRisk(tags) {
      return tags.find((v) => v.text == '用时过长')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ItemMealCard {
  width: 100%;
  height: 194px;
  // min-height: 194px;
  box-sizing: border-box;
  background: #f7f7f7;
  border-radius: 6px;
  border: 1px solid #f1f1f1;
  margin-top: 10px;
  display: flex;
  align-items: stretch;
  justify-content: center;
  .c-item {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .i-title {
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #f1f1f1;
      font-size: 13px;
    }
    .i-cent {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: space-between;
      margin-top: 6px;
      margin-bottom: 12px;
      .c-num {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: 600;
      }
      .c-nums {
        font-size: 15px;
        font-weight: 500;
        span {
          font-weight: 400;
          font-size: 10px;
        }
      }
      .c-nums-risk {
        color: #f04646;
      }
      .c-tag {
        width: 50px;
        height: 15px;
        background: #35c763;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 10px;
        font-weight: 500;
        margin-top: 4px;
      }
      .i-bot {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        text-align: center;
        line-height: 18px;
        .c-sub {
          font-size: 12px;
          .sub-num {
            font-weight: 600;
          }
          .sub-num-risk {
            color: #f04646;
          }
        }
        .c-sub-gray {
          color: #7f7f7f;
        }
      }
    }
    & + .c-item {
      border-left: 1px solid #f1f1f1;
    }
  }
}
</style>
